import request from 'superagent'
import {executeMapQuery, executeListQuery, estateSummaries, estateDetails} from 'conf'

export const getList = (query, cb) =>
  request
    .post(executeListQuery())
    .set('Accept', 'application/json')    
    .send(query)
    .end((err, res) => err ? cb(err) : cb(null, res.body))

export const mapSearch = (query, cb) => 
  request
    .post(executeMapQuery())
    .set('Accept', 'application/json')
    .send(query)
    .end((err, res) => err ? cb(err) : cb(null, res.body))

export const getSummaries = (estatesIds, cb) =>
  request
    .post(estateSummaries())
    .set('Accept', 'application/json')
    .send(estatesIds)
    .end((err, res) => err ? cb(err) : cb(null, res.body))

export const getDetails = (estateId, cb) => 
  request
    .get(estateDetails(estateId))
    .end((err, res) => err ? cb(err) : cb(null, res.body))




/** WEBPACK FOOTER **
 ** ./app/api/search.js
 **/